// theme/scripts/contexts/customize.js

import React, { createContext, useEffect, useMemo, useState } from 'react';

const defaultData = {
  collar: {
    id: '',
    label: '',
    value: '',
    img: '',
    cleric_type: [
      {
        id: '',
        label: '',
        value: ''
      }
    ]
  },
  back: {
    id: '',
    value: '',
    label: '',
    img: ''
  },
  cuffs: {
    id: '',
    value: '',
    label: '',
    img: '',
    cuffs_type: [
      {
        id: '',
        label: '',
        value: ''
      }
    ]
  },
  plackets: {
    id: '',
    value: '',
    label: '',
    img: ''
  },
  pocket: {
    id: '',
    value: '',
    label: '',
    img: ''
  },
  button: {
    id: '',
    value: '',
    label: '',
    img: ''
  },
  sizes: {
    base: {
      id: '',
      label: ''
    },
    chest_size: {
      id: '',
      label: '',
      value: ''
    },
    collar_size: {
      id: '',
      label: '',
      value: ''
    },
    body_length: {
      id: '',
      label: '',
      value: ''
    },
    sleeve_length_left: {
      id: '',
      label: '',
      value: ''
    },
    sleeve_length_right: {
      id: '',
      label: '',
      value: ''
    },
    cuffs_width_left: {
      id: '',
      label: '',
      value: ''
    },
    cuffs_width_right: {
      id: '',
      label: '',
      value: ''
    },
    waist_size: {
      id: '',
      label: '',
      value: ''
    },
    yoke_size: {
      id: '',
      label: '',
      value: ''
    },
    sleeve_width: {
      id: '',
      label: '',
      value: ''
    }
  },
  embroideryOptions: {
    embroidery: {
      value: ''
    },
    embroidery_color: {
      id: '',
      value: '',
      img: ''
    },
    embroidery_type: {
      id: '',
      value: '',
      img: ''
    },
    embroidery_place: {
      id: '',
      value: '',
      img: ''
    },
    embroidery_format: {
      id: '',
      value: ''
    },
    embroidery_initial: {
      value: ''
    }
  },
  brand_name: {
    id: '',
    value: '',
    label: ''
  },
  kamakura_name: {
    id: '',
    value: '',
    label: ''
  }
};

const isEmpty = (v) => v === '' || v === null || v === undefined;

const mergeDeepPreferNonEmpty = (prev, patch) => {
  if (patch === undefined) return prev;
  if (Array.isArray(prev) || Array.isArray(patch)) {
    return patch ?? prev;
  }
  if (typeof prev === 'object' && prev && typeof patch === 'object' && patch) {
    const out = { ...prev };
    const keys = new Set([...Object.keys(prev), ...Object.keys(patch)]);
    keys.forEach((k) => {
      if (k in patch) out[k] = mergeDeepPreferNonEmpty(prev[k], patch[k]);
      else out[k] = prev[k];
    });
    return out;
  }
  return isEmpty(patch) ? prev : patch;
};

export const CustomizeContext = createContext();

export const CustomizeProvider = ({ children }) => {
  const [customizes, setCustomizeForm] = useState(defaultData);

  const setCustomizes = (updater) => {
    setCustomizeForm((prev) => {
      const patch = typeof updater === 'function' ? updater(prev) : updater;
      return mergeDeepPreferNonEmpty(prev, patch);
    });
  };

  const setCustomizesForce = (updater) => {
    setCustomizeForm((prev) => {
      const patch = typeof updater === 'function' ? updater(prev) : updater;
      return { ...prev, ...patch };
    });
  };

  const value = useMemo(
    () => ({ customizes, setCustomizes, setCustomizesForce }),
    [customizes]
  );
  return <CustomizeContext.Provider value={value}>{children}</CustomizeContext.Provider>;
};
